<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

defineEmits(['close'])
const showContinueButton = ref(false)
const timeoutId = ref(null)

onMounted(() => {
  timeoutId.value = setTimeout(() => {
    showContinueButton.value = true
  }, 4000)
})

onUnmounted(() => {
  clearTimeout(timeoutId.value)
})

</script>

<template>
  <Transition name="fade" mode="out-in" appear>
    <Teleport to="body">
      <div class="modal-overlay">
        <div class="modal-content">
          <img src="@/assets/images/pro-icon.png" />
          <h2 class="heading-2 primary-color">Congratulations</h2>
          <p class="p-md lighter">You're now a pro member of Sparkle.</p>
          <button v-if="showContinueButton" class="btn btn-primary btn-lg" @click="$emit('close')">
            Continue
          </button>
          <span v-else>
            Redirecting...
          </span>
        </div>
      </div>
    </Teleport>
  </Transition>
</template>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(31, 32, 42, 0.3);
  z-index: 1000;
}

.modal-content {
  position: absolute;
  /* Change positioning according to r need, you can do this by passsing a style prop also */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: white;
  display: flex;
  width: 480px;
  max-width: 80%;
  padding: 32px 24px;
  align-items: center;
  border-radius: 16px;
  gap: 12px;
}

img {
  width: 100px;
  height: 100px;
}

.lighter {
  color: var(--Web-Colors-Neutrals-500, #525866);
  margin-bottom: 8px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: 480px) {
  .heading-2 {
    font-size: 32px;
  }
}
</style>
